export default __webpack_public_path__ + "static/media/break24.607940fb.jpg";